/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropUnifiedContentItem } from './DropUnifiedContentItem';
import {
    DropUnifiedContentItemFromJSON,
    DropUnifiedContentItemFromJSONTyped,
    DropUnifiedContentItemToJSON,
    DropUnifiedContentItemToJSONTyped,
} from './DropUnifiedContentItem';

/**
 * 
 * @export
 * @interface DropAggregateContentResponse
 */
export interface DropAggregateContentResponse {
    /**
     * 
     * @type {Array<DropUnifiedContentItem>}
     * @memberof DropAggregateContentResponse
     */
    items: Array<DropUnifiedContentItem>;
    /**
     * 
     * @type {number}
     * @memberof DropAggregateContentResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropAggregateContentResponse interface.
 */
export function instanceOfDropAggregateContentResponse(value: object): value is DropAggregateContentResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropAggregateContentResponseFromJSON(json: any): DropAggregateContentResponse {
    return DropAggregateContentResponseFromJSONTyped(json, false);
}

export function DropAggregateContentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropAggregateContentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DropUnifiedContentItemFromJSON)),
        'computedAt': json['computedAt'],
    };
}

export function DropAggregateContentResponseToJSON(json: any): DropAggregateContentResponse {
    return DropAggregateContentResponseToJSONTyped(json, false);
}

export function DropAggregateContentResponseToJSONTyped(value?: DropAggregateContentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(DropUnifiedContentItemToJSON)),
        'computedAt': value['computedAt'],
    };
}

